import { IOpsScheduleDay } from "./day"
import { OpsScheduleStatus } from "@nkr/enums/ops-schedule-status"

export interface IOpsSchedule {
    id: number,
    employeeId: number,
    backgroundColor: string
    color: string,
    displayOrder: number,
    status: OpsScheduleStatus,
    days: IOpsScheduleDay[]
}